import React from 'react'
import { Row, Col} from 'antd'
import FilterAccount from './filter-account'
import FilterMonth from './filter-month'
import './filters.scss'

export default ({ handleCloudAccountChange, selectedAccount, selectedYear, selectedMonth, cloudAccounts, on_cloud_account_change, on_year_change, on_month_change }) => (
    <div>
        <Row gutter={16} className="filter-container">
            <Col span={5}>
                {/* <FilterAccount on_cloud_account_change={on_cloud_account_change} selectedAccount={selectedAccount} cloudAccounts={ cloudAccounts } /> */}
            </Col>
            <Col span={19}>
                <FilterMonth selectedYear={selectedYear} selectedMonth={selectedMonth} on_year_change={on_year_change} on_month_change={on_month_change} />
            </Col>
        </Row>
    </div>
)